import { motion } from "framer-motion";
import { useIsMobile } from "@/hooks/use-mobile";

interface MarqueeLogoItem {
  name: string;
  logo: string;
}

interface MarqueeTickerProps {
  items: string[] | MarqueeLogoItem[];
  className?: string;
}

const isLogoItems = (items: string[] | MarqueeLogoItem[]): items is MarqueeLogoItem[] =>
  items.length > 0 && typeof items[0] === "object";

const MarqueeTicker = ({ items, className = "" }: MarqueeTickerProps) => {
  const isMobile = useIsMobile();
  const duplicated = [...items, ...items];
  const logoMode = isLogoItems(items);

  const duration = isMobile ? items.length * (logoMode ? 2.72 : 3.4) : items.length * (logoMode ? 8.16 : 10.88);

  return (
    <div className={`overflow-hidden ${className}`}>
      <motion.div
        key={isMobile ? "mobile" : "desktop"}
        className={`flex items-center whitespace-nowrap w-max ${logoMode ? "gap-12 md:gap-16" : "gap-6"}`}
        animate={{ x: ["0%", "-50%"] }}
        transition={{
          x: {
            repeat: Infinity,
            repeatType: "loop",
            duration,
            ease: "linear",
          },
        }}
      >
        {duplicated.map((item, i) =>
          typeof item === "string" ? (
            <span
              key={`${item}-${i}`}
              className="inline-flex items-center text-sm text-muted-foreground shrink-0"
            >
              {item}
            </span>
          ) : (
            <div
              key={`${item.name}-${i}`}
              className="inline-flex items-center justify-center shrink-0 h-10 md:h-14"
            >
              <img
                src={item.logo}
                alt={item.name}
                className="h-full w-auto max-w-[140px] md:max-w-[180px] object-contain"
                style={{ filter: "grayscale(100%) opacity(0.55)", mixBlendMode: "multiply" }}
                loading="lazy"
              />
            </div>
          )
        )}
      </motion.div>
    </div>
  );
};

export default MarqueeTicker;
